export const metaAppsUrls = {
    metaApp: (metaAppId?: number) => (metaAppId ? `meta-app/${metaAppId}` : "meta-app"),
    metaAppType: (metaAppTypeId?: number) => (metaAppTypeId ? `meta-app-type/${metaAppTypeId}` : "meta-app-type"),
    metaAppTypeModal: {
        formData: "meta-app-type/form-data",
        qbeFilterFormData: "meta-app-type/qbe-form-data",
    },
};
